import React from "react";
import { signInWithRedirect } from "aws-amplify/auth";
import GenAiButton from "../ThreatModeling/GenAiButton";
import Shield from "../ThreatModeling/images/shield.png";
import { useTheme } from "../ThemeContext";
import styled from "@emotion/styled";
import "./LoginForm.css";

const Title = styled.h1`
  font-size: 26px;
  font-weight: 200;
  margin-bottom: 40px;
`;

const LoginForm = ({ onSignInSuccess }) => {
  const { isDark } = useTheme();

  const handlePhilipsSso = async () => {
    await signInWithRedirect({
      provider: { custom: "PhilipsAzure" },
    });
  };

  return (
    <div className={`login-container ${isDark ? "dark-theme" : "light-theme"}`}>
      <div className="form-container">
        <img src={Shield} alt="Threat Designer logo" style={{ width: "80px" }} />
        <Title>AI Threat Modeling Assistant</Title>
        <div className="button-group">
          <GenAiButton onClick={handlePhilipsSso}>Single Sign-On</GenAiButton>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
